import { ScrollContainer } from '@frameio/vapor';
import styles from './ItemDetailContainer.module.css';

type ItemDetailContainerProps = {
  ref?: (element: HTMLElement | SVGElement | null) => void;
  imageComponent?: React.ReactNode;
  titleComponent?: React.ReactNode;
  actionsComponent?: React.ReactNode;
  metaComponent?: React.ReactNode;
  matchesComponent?: React.ReactNode;
  onScroll?: (e: React.UIEvent<HTMLDivElement>) => void;
  scrollPaddingTop?: number;
};

export const ItemDetailContainer = ({
  ref,
  imageComponent,
  titleComponent,
  actionsComponent,
  metaComponent,
  matchesComponent,
  onScroll,
  scrollPaddingTop,
}: ItemDetailContainerProps) => {
  return (
    <ScrollContainer
      ref={ref}
      data-testid="quick-search-v2-item-detail-container"
      height="100%"
      onScroll={onScroll}
      overflow="auto"
      paddingX={16}
      position="relative"
      width="100%"
    >
      <div
        className={styles.itemDetailContainer}
        style={scrollPaddingTop ? { paddingTop: scrollPaddingTop } : undefined}
      >
        <div className={styles.contentContainer}>
          <div className={styles.imageContainer}>{imageComponent}</div>
          <div>{titleComponent}</div>
          <div className={styles.actionsContainer}>{actionsComponent}</div>
        </div>

        <div>{metaComponent}</div>

        {matchesComponent && (
          <div className={styles.matchesContainer}>{matchesComponent}</div>
        )}
      </div>
    </ScrollContainer>
  );
};
